module.exports = __webpack_public_path__ + "static/media/jp.3e72015c.svg";